import { render } from "./IsbnBookInfo.vue?vue&type=template&id=13484ec5&scoped=true"
import script from "./IsbnBookInfo.vue?vue&type=script&lang=js"
export * from "./IsbnBookInfo.vue?vue&type=script&lang=js"

import "./IsbnBookInfo.vue?vue&type=style&index=0&id=13484ec5&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13484ec5"]])

export default __exports__